<template>
  <div class="container">
    <div class="list-header">
      <van-icon @click="$router.back(-1)" class="back-top-icon" name="arrow-left" />
      <div class="header-title">用户管理</div>
      <div class="header-left">&nbsp;</div>
    </div>
    <div class="h85"></div>
    <div class="u-list">
      <div v-for="item in list" :key="item.uuid" class="u-item">
        <div class="u-info">
          <div class="u-info-t">{{item.name}}<div class="u-info-age">{{item.age}}岁</div></div>          
          <div class="u-info-status" :class="{'un-active': item.status === 1}">
            <span :class="{'un-active-bg': item.status === 1}">&nbsp;</span>
            {{item.status === 1 ? '离线' : '在线' }}
          </div>
        </div>
        <div class="u-btn">
          <div @click="del(item)" class="u-btn-l">删除</div>
          <div @click="edit(item)" class="u-btn-r">编辑</div>
        </div>
      </div>
    </div>
    <!-- 新增按钮 -->
    <div @click="addUser()" class="add-btn">新建用户</div>
    <div class="h85"></div>
    <div class="h85"></div>
    <!-- 新增编辑弹窗 -->
    <div class="add-mask" v-show="showAdd">
      <div class="add-mask-body">
        <div class="add-mask-head">
          <div>{{title}}</div>
          <van-icon @click="showAdd = false" name="cross" color="#999999" size=".3rem"/>
        </div>
        <div class="add-cell">
          <div class="add-cell-tip">姓名</div>
          <van-field
            v-model.trim="form.name"
            label=""
            label-width="0"
            placeholder="请输入姓名"
            maxlength="10"
          />
        </div>
        <div class="add-cell">
          <div class="add-cell-tip">年龄</div>
          <van-field
            v-model="form.age"
            label=""
            label-width="0"
            placeholder="请输入年龄"
            maxlength="3"
          />
        </div>
        <div class="add-flag">
          {{ form.id ? `ID：${form.id}` : ' '}}
        </div>
        <div class="add-btns">
          <div @click="showAdd = false" class="add-btn del">取消</div>
          <div @click="submit" v-preventReClick class="add-btn sure">确认</div>
        </div>
      </div>
    </div>
    <!-- 删除二次确认 -->
    <div class="del-mask" v-show="showDel">
      <div class="del-mask-body">
        <div class="del-mask-head">
          <div>删除用户</div>
          <van-icon @click="showDel = false" name="cross" color="#999999" size=".3rem"/>
        </div>
        <div class="del-mask-tip">用户删除后，用户及数据不可恢复<br>是否删除此用户？</div>
        <div class="del-btns">
          <div @click="doDel" v-preventReClick class="del-btn del">确认</div>
          <div @click="showDel = false" class="del-btn sure">再想想</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, RadioGroup, Radio, Field, Popup, Picker } from 'vant';
import { range, forEach, isArray } from 'lodash';
import moment from 'moment';
// console.log(tiZhongColumns, '----')
import { getUserList, syncSubUser, creteUser, updateUser, delUser } from '@/api/user.js'

export default {
  components: {[Icon.name]: Icon, [RadioGroup.name]: RadioGroup, [Radio.name]: Radio, [Field.name]: Field, [Popup.name]: Popup, [Picker.name]: Picker},
  data() {
    return {
      showDel: false,
      showAdd: false,
      title: '',
      form: {
        name: '',
        age: '',
        uuid: ''
      },
      list:[]
    }
  },
  created() {
    // const memberId = sessionStorage.getItem('userId')
    syncSubUser({}).then(res => {
      console.log(res, 'syncSubUser')
      this.getList()
    })    
  },
  methods: {
    getList() {
      getUserList({}).then(res2 => {
        console.log(res2)
        this.list = res2
      })
    },
    addUser() {
      this.title = '新增用户'      
      this.form = {
        name: '',
        age: '',
        uuid: ''
      }
      this.$nextTick(() => {
        this.showAdd = true
      })
    },
    doDel() {
      delUser(this.form.uuid).then(res=> {
        this.$toast('删除成功')
        this.getList();
        this.showDel = false
      })
    },
    del(item) {    
      this.form = {
        name: item.name,
        age: item.age,
        uuid: item.uuid
      }
      this.$nextTick(() => {
        this.showDel = true
      })
    },
    edit(item) {
      this.title = '编辑用户'
      this.form = {
        name: item.name,
        age: item.age,
        uuid: item.uuid
      }
      this.$nextTick(() => {
        this.showAdd = true
      })
    },
    submit() {
      if(!this.form.name) {
        this.$toast('请输入姓名')
        return
      }
      const agePattern = /^([1-9]|[1-9]\d|1[0-1]\d|120)$/;
      if(!agePattern.test(this.form.age)) {
        this.$toast('请输入正确的年龄')
        return
      }
      if(this.form.uuid) {
        updateUser({...this.form}).then(res => {
          this.$toast('更新成功')
          this.getList();
          this.showAdd = false;
        })
      } else {
        creteUser({...this.form, uuid: undefined}).then(res => {
          this.$toast('新增成功')
          this.getList();
          this.showAdd = false;
        }) 
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  min-height: 100vh;
  background: #FFF;
  .add-btn {
    margin: 3rem auto;
    width: 4.17rem;
    height: .77rem;
    line-height: .77rem;
    background: #0074FE;
    border-radius: .38rem;
    color: #fff;
    text-align: center;
    font-weight: 500;
    font-size: .27rem;
  }
  .add-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
    .add-mask-body {
      margin: 3.4rem auto 0;
      padding: .38rem;
      position: relative;
      width: 5.97rem;
      // height: 3.86rem;
      background: #FFFFFF;
      border-radius: .12rem;
      .add-flag {
        // width: 2.85rem;
        padding: .19rem 0 .29rem;
        height: .38rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: .27rem;
        color: #000000;
        text-align: center;
      }
      .add-cell {
        padding-top: .29rem;
        /deep/ .van-cell {
          border: .02rem solid #eee;
          border-radius: .08rem;
          height: .62rem;
          line-height: .62rem;
          padding: 0;
          padding-left: .2rem;
          font-weight: 400;
          font-size: .27rem;
          color: #999999;
        }
        .add-cell-tip{
          font-weight: 400;
          font-size: .27rem;
          color: #000000;
          padding-bottom: .19rem;
        }
      }
      .add-mask-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 500;
        font-size: .31rem;
        color: #000000;
      }
      .add-btns {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: .77rem;
        .add-btn {
          width: 1.79rem;
          height: .77rem;
          border-radius: .12rem;
          font-weight: 500;
          font-size: .27rem;
          text-align: center;
          line-height: .77rem;
        }
        .sure {
          color: #FFF;
          background: #0074FE;
        }
        .del {
          background: #EEE;
          color: #999;
        }
      }
    }
  }
  .del-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
    .del-mask-body {
      margin: 3.4rem auto 0;
      padding: .38rem;
      position: relative;
      width: 5.97rem;
      height: 3.86rem;
      background: #FFFFFF;
      border-radius: .12rem;
      .del-mask-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 500;
        font-size: .31rem;
        color: #000000;
      }
      .del-mask-tip {
        padding: .5rem 0 .8rem;
        // width: 4.62rem;
        text-align: center;
        height: 1.15rem;
        font-weight: 400;
        font-size: .31rem;
        color: #000000;
        line-height: .58rem;
      }
      .del-btns {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: .77rem;
        .del-btn {
          width: 1.79rem;
          height: .77rem;
          border-radius: .12rem;
          font-weight: 500;
          font-size: .27rem;
          text-align: center;
          line-height: .77rem;
        }
        .sure {
          color: #FFF;
          background: #0074FE;
        }
        .del {
          background: #EEE;
          color: #999;
        }
      }
    }
  }
  .u-list {
    padding: 0.3rem 0 .4rem 0.3rem;
    display: flex;
    flex-wrap: wrap;
    gap: .2rem;
    .un-active {
      color: #999 !important
    }
    .un-active-bg {
      background: #999 !important;
    }
    .u-item {
      width: 3.37rem;
      height: 1.69rem;
      background: #F6F8F9;
      border-radius: .12rem;
      .u-btn {
        height: .65rem;
        background: #EEE;
        border-radius: 0 0 .12rem .12rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // background: url('../../accesst/user/btns.png') no-repeat;
		background: url(data:image/png;base64,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) no-repeat;
        background-size: 3.37rem .65rem;
        .u-btn-l {
          width: 1.27rem;
          height: .65rem;
          line-height: .65rem;
          text-align: center;
        }
        .u-btn-r {
          line-height: .65rem;
          color: #FFF;
          width: 2.17rem;
          height: .65rem;
          text-align: center;
        }
      }
      .u-info {
        padding: .29rem .15rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .u-info-t {
          font-weight: 500;
          font-size: .31rem;
          color: #000000;          
        }
        .u-info-age {
          margin-left: .15rem;
          display: inline-block;
          font-weight: 400;
          font-size: .27rem;
          color: #666666;
        }
        .u-info-status {
          font-weight: 600;
          font-size: .27rem;
          color: #00AD81;
          span {
            display: inline-block;
            width: .2rem;
            height: .2rem;
            border-radius: 50%;
            background: #00AD81;
            margin-right: .05rem;
            vertical-align: middle;
          }
        }
      }
    }
  }
  .h85 {
    height: .85rem;
  }
  .list-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9;
    height: .85rem;
    padding: 0 .46rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FFF;
    .back-top-icon {
      width: .3rem;
      font-size: .32rem;
      color: #000;
      font-weight: bolder;
    }
    .header-title {
      font-size: .31rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #000000;
    }
    .header-left {
      width: .3rem;
    }
  }
}
</style>